<template>
  <div>
    <b-btn variant="danger" block class="font-weight-bold mb-3" @click="showModal">
      Cancel Tab
      <span v-if="$showApprove([3, 4, 5, 11, 12])">
        *
      </span>
    </b-btn>
    <approve-permission
      :orderId="order.OrderID"
      :tab-no="order.TabNo"
      action-type="CancelTab"
      @acceptPermission="openWithAcceptPermission"
      v-model="approveModal"
    />
    <Cmodal
      v-model="modal"
      cancel-label="Never mind"
      centered
      title="Cancel Tab"
      :tag="false"
      confirm-label="Cancel Tab and Notify Customer"
      :progressing="progressing"
      size="md"
      @submit="cancel"
    >
      <template>
        <p>Select cancellation reason to notify the customer</p>
        <b-form-group>
          <b-form-checkbox-group stacked id="checkbox-group-2" v-model="selected" name="flavour-2">
            <b-form-radio
              v-for="(item, index) in cancelData"
              :key="index"
              class="my-3"
              :value="item.Text"
              v-model="CancelReason"
              name="CancelReason"
              >{{ item.Text }}
            </b-form-radio>
            
            
          </b-form-checkbox-group>
          <div v-if="CancelReason === 'Custom - Enter your own message'" class="text-right">
                    <span class="small text-right">100 Characters Max</span>
          </div>
          <b-form-textarea
          maxlength="100"
                v-if="CancelReason === 'Custom - Enter your own message'"
                v-model="ReasonText"
                placeholder="Enter cancelation reason..."
                rows="3"
                max-rows="6">
            </b-form-textarea>
        </b-form-group>
      </template>
    </Cmodal>
  </div>
</template>

<script>
import Cmodal from './Cmodal'
import approvePermission from './approvePermission'
export default {
  name: 'cancelTab',
  components: {
    Cmodal,
    approvePermission
  },
  props: {
    cancelData: {
      required: true
    },
    progressing: {
      required: false
    },
    order: {
      required: true
    }
  },
  data() {
    return {
      modal: false,
      CancelReason: null,
      approveModal: false,
      showTextArea:false,
      ReasonText:"",
    }
  },
  methods: {
    showModal() {
      if (this.$showApprove([3, 4, 5, 11, 12])) {
        this.approveModal = true
      } else {
        this.modal = true
        this.CancelReason = null
      }
    },
    openWithAcceptPermission() {
      this.approveModal = false
      this.modal = true
      this.CancelReason = null
    },
    cancel() {
      if (this.CancelReason === null) {
        this.$showError('please select one cancel reason')

      }else if(this.CancelReason === "Custom - Enter your own message" && this.ReasonText === ""){
        this.$showError('please explain the reason')

      } else {
        if(this.CancelReason === "Custom - Enter your own message")
          this.CancelReason = this.ReasonText
        this.modal = false
        this.ReasonText = ''
        this.$emit('cancelOrder', this.CancelReason)
      }
    }
  }
}
</script>

<style scoped></style>
